import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { ChannelName } from "../../../../channels/types";
import type { ToTarget } from "../../../../to/use-to-target";
import {
  type PersonInUnsavedSegmentWithChannels,
  SupabaseSegmentService,
} from "../../../server/supabase-segment-service";
import type { Segment } from "../../../types";

export function useSegmentRecipients(
  segment: Pick<Segment, "operation" | "conditions">,
  filterChannel?: ChannelName,
  target_connection_type?: ToTarget["target_connection_type"],
): UseSupabaseLoaderState<PersonInUnsavedSegmentWithChannels[]> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await new SupabaseSegmentService(supabase).getAllUnsavedRecipients(
        account_id,
        segment,
        target_connection_type || undefined,
      );
      if (error) throw new Error(error.message);
      return data
        .map((x) => ({
          ...x,
          channels: x.channels as PersonInUnsavedSegmentWithChannels["channels"],
        }))
        .filter((x) => (filterChannel ? x.channels[filterChannel] : true));
    },
    [segment, filterChannel, target_connection_type],
  );
}
